// extracted by mini-css-extract-plugin
export default {"paging":"DataTablePaging__paging___25CRU"};